const CerezPolitikasiPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative py-20 md:py-32 bg-gradient-to-br from-gray-900 via-black to-gray-800 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-l from-gray-400 to-transparent rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-r from-gray-500 to-transparent rounded-full blur-3xl"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-gray-100 mb-4">
            Çerez Politikası
            <span className="block mt-3 md:mt-4 bg-gradient-to-r from-gray-300 via-gray-100 to-gray-400 bg-clip-text text-transparent">
              Cookie Policy
            </span>
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12 md:py-24">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <div className="bg-gray-100 rounded-3xl shadow-xl p-6 md:p-12 space-y-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">1. Çerez Nedir?</h2>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcılar aracılığıyla cihazınıza veya ağ sunucusuna depolanan küçük metin dosyalarıdır. Web sitemizi ziyaret ettiğinizde, kişisel verileriniz 6698 sayılı Kişisel Verilerin Korunması Kanunu'na uygun olarak işlenebilmektedir.
              </p>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">2. Çerez Türleri</h2>
              <p className="text-gray-700 leading-relaxed mb-4 text-sm md:text-base">
                Web sitemizde kullanılan çerez türleri:
              </p>
              
              <div className="space-y-4">
                <div>
                  <h3 className="text-lg md:text-xl font-semibold text-black mb-2">Zorunlu Çerezler</h3>
                  <p className="text-gray-700 text-sm md:text-base">
                    Web sitesinin düzgün çalışması için gerekli olan çerezlerdir. Bu çerezler olmadan web sitesi düzgün çalışmayacaktır.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg md:text-xl font-semibold text-black mb-2">Performans Çerezleri</h3>
                  <p className="text-gray-700 text-sm md:text-base">
                    Ziyaretçilerin web sitesini nasıl kullandığına dair bilgi toplayan çerezlerdir. Bu çerezler, web sitesinin performansını artırmak için kullanılır.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg md:text-xl font-semibold text-black mb-2">İşlevsellik Çerezleri</h3>
                  <p className="text-gray-700 text-sm md:text-base">
                    Kullanıcı tercihlerini hatırlayan ve web sitesi deneyimini kişiselleştiren çerezlerdir.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg md:text-xl font-semibold text-black mb-2">Hedefleme/Reklam Çerezleri</h3>
                  <p className="text-gray-700 text-sm md:text-base">
                    Kullanıcıların ilgi alanlarına göre özelleştirilmiş reklamlar göstermek için kullanılan çerezlerdir.
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">3. Çerezlerin Kullanım Amaçları</h2>
              <p className="text-gray-700 leading-relaxed mb-4 text-sm md:text-base">
                Web sitemizde çerezler aşağıdaki amaçlarla kullanılmaktadır:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 text-sm md:text-base">
                <li>Web sitesinin düzgün çalışmasını sağlamak</li>
                <li>Kullanıcı deneyimini iyileştirmek</li>
                <li>Web sitesi trafiğini analiz etmek</li>
                <li>Kullanıcı tercihlerini hatırlamak</li>
                <li>Güvenlik önlemlerini sağlamak</li>
                <li>İçerik ve reklamları kişiselleştirmek</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">4. Çerezlerin Kontrolü</h2>
              <p className="text-gray-700 leading-relaxed mb-4 text-sm md:text-base">
                Tarayıcınızın ayarlarını değiştirerek çerezlere ilişkin tercihlerinizi kişiselleştirme imkânına sahipsiniz. Tarayıcınızın ayarlarını kullanarak çerezleri engelleyebilir, silebilir veya çerez kullanılmadan önce uyarı alabilirsiniz.
              </p>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                Ancak, çerezleri devre dışı bırakmanız durumunda web sitemizin bazı özelliklerinin düzgün çalışmayabileceğini lütfen unutmayın.
              </p>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">5. Tarayıcı Ayarları</h2>
              <p className="text-gray-700 leading-relaxed mb-4 text-sm md:text-base">
                Çerez ayarlarınızı değiştirmek için tarayıcınızın yardım bölümünü ziyaret edebilirsiniz:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 text-sm md:text-base">
                <li>Google Chrome: Ayarlar &gt; Gizlilik ve güvenlik &gt; Çerezler</li>
                <li>Mozilla Firefox: Seçenekler &gt; Gizlilik ve Güvenlik &gt; Çerezler</li>
                <li>Safari: Tercihler &gt; Gizlilik &gt; Çerezler</li>
                <li>Microsoft Edge: Ayarlar &gt; Gizlilik, arama ve hizmetler &gt; Çerezler</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">6. Çerez Politikası Güncellemeleri</h2>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                Bu Çerez Politikası, yasal düzenlemelerdeki değişiklikler veya web sitemizdeki güncellemeler nedeniyle zaman zaman güncellenebilir. Güncellemeler bu sayfada yayınlanacaktır.
              </p>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">7. İletişim</h2>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                Çerez Politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
              </p>
              <div className="mt-4 space-y-2 text-gray-700 text-sm md:text-base">
                <p><strong>Adres:</strong> 677/12. Sk. 40A, 35380 İzmir, Buca</p>
                <p><strong>Telefon:</strong> 0505 049 87 11</p>
              </div>
            </div>

            <div className="pt-6 border-t border-gray-300">
              <p className="text-gray-600 text-xs md:text-sm">
                Son Güncelleme: {new Date().toLocaleDateString('tr-TR')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/905050498711?text=Merhaba,%20SKDetailing.com.tr%20üzerinden%20iletişime%20geçiyorum."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 md:bottom-8 right-6 md:right-8 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#25D366] rounded-full shadow-2xl hover:scale-110 hover:shadow-green-500/50 transition-all duration-300 z-50 cursor-pointer group"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl md:text-3xl text-gray-100 group-hover:text-gray-200"></i>
      </a>
    </div>
  );
};

export default CerezPolitikasiPage;
